import styled from "styled-components";
import { Flex } from "../../ui";
export const CategoryIconContainer = styled(Flex) `
  align-items: center;
  justify-content: center;
  width: ${({ size }) => size ?? "2.5rem"};
  height: ${({ size }) => size ?? "2.5rem"};
  box-sizing: border-box;
`;
